import { useEffect, useRef, type RefObject } from "react";

/**
 * Closes an open header panel on Escape (focus goes back to its button, `restoreFocus` true) and on a press
 * anywhere outside `wrapRef` (focus stays where the press put it). Listens only while the panel is open.
 */
export function useDismiss(open: boolean, wrapRef: RefObject<HTMLElement>, onDismiss: (restoreFocus: boolean) => void) {
  const latest = useRef(onDismiss);
  latest.current = onDismiss;
  useEffect(() => {
    if (!open) return;
    const onPointerDown = (e: PointerEvent) => {
      if (!wrapRef.current?.contains(e.target as Node)) latest.current(false);
    };
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") latest.current(true);
    };
    document.addEventListener("pointerdown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open, wrapRef]);
}
